import { DEFAULT_LOCALE, isValidLocale } from "@/app/lib/i18n-config";
import type { Translations } from "./index";

// Same order as the spreads in ./index
const NAMESPACES = [
  "common",
  "auth",
  "dashboard",
  "marketing",
  "forms",
  "job-page",
];

/**
 * Load one locale's translations on demand (unknown locales get German).
 * Client code must import this, not ./index: its static imports put every
 * locale (~1 MB gzipped) into the client bundle.
 */
export async function loadTranslations(locale: string): Promise<Translations> {
  const lang = isValidLocale(locale) ? locale : DEFAULT_LOCALE;
  const parts = await Promise.all(
    NAMESPACES.map(ns => import(`./langs/${lang}/${ns}.json`))
  );
  return Object.assign({}, ...parts.map(part => part.default));
}
